import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RegisterService } from './register.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  errMsg: string = '';
  consentModalDialog;
  confirmModalDialog;
  passwordType: boolean;
  confirmPasswordType: boolean;

  constructor(
    private fb: FormBuilder,
    private registerService: RegisterService,
    private router: Router,
    public matDialog: MatDialog,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      gender: ['', Validators.required],
      dateOfBirth: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
      // password: ['', [Validators.required, Validators.pattern("^(?=.*\d)(?=.*[a-zA-Z]).{6,10}$")]]
    })
    this.gobalFunctionService.setSEO('สมัครสมาชิก Life Di', 'website', '');
  }

  createAccount(): void {
    const body = {
      USERNAME: this.registerForm.get('username').value,
      EMAIL: this.registerForm.get('email').value,
      GENDER: this.registerForm.get('gender').value,
      DATE_OF_BIRTH: this.registerForm.get('dateOfBirth').value,
      PASSWORD: this.registerForm.get('password').value,
      CONFIRMPASSWORD: this.registerForm.get('confirmPassword').value
    }
    const _checkEmail = this.registerService.checkEmail(body.EMAIL).subscribe(resCheck => {
      this.openConsentModal();
      this.consentModalDialog.afterClosed().subscribe(res => {
        // // console.log(res);
        if (res) {
          const _createAccount = this.registerService.createAccount(body).subscribe(resCreate => {
            this.openConfirmToEmailModal();
            this.confirmModalDialog.afterClosed().subscribe(res => {
              _createAccount.unsubscribe();
              _checkEmail.unsubscribe();
              this.router.navigate(['/login']);
            })
          }, errorCreate => {
            // // console.log(errorCreate);
            this.errMsg = errorCreate.error.message;
          });
        }
      });

    }, errorCheck => {
      // console.error(errorCheck);
      this.errMsg = errorCheck.error.message;
    });
  }

  get checkEmail() {
    return this.registerForm.get('email');
  }

  openConsentModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConsent";
    dialogConfig.data = {
      name: "consent",
      title: "การยินยอม",
      description: `
      <h5 class="mt-2"><b>นโยบายความเป็นส่วนตัว</b></h5>
      <div class="text-left">
      -	โครงการในเว็บไซต์นี้เป็นโครงการวิจัย ไม่ใช่ การรักษาตามปกติ <br>
      -	การเข้าร่วมการวิจัยนี้ขึ้นอยู่กับความสมัครใจ ท่านสามารถตัดสินใจได้อย่างอิสระว่าจะเข้าร่วมหรือไม่เข้าร่วมการวิจัยนี้ ท่านไม่จำเป็นจะต้องเข้าร่วมในโครงการวิจัยนี้ <br>
      -	นักวิจัยผู้ขอความยินยอมต้องให้ ข้อมูลและเวลาที่เพียงพอ ในการตัดสินใจอย่างอิสระ ก่อนที่ท่านจะเข้าร่วมโครงการวิจัย <br>
      -	ท่านสามารถซักถามข้อสงสัยเกี่ยวกับโครงการวิจัยได้ ซึ่งผู้วิจัยจะอธิบายเพิ่มเติมแก่ท่านและตอบข้อซักถามจนท่านเข้าใจ <br>
      -	หากท่านสมัครใจเข้าร่วมการวิจัยนี้แล้ว ท่านยังคงสามารถถอนตัวออกจากการวิจัยได้ทุกเมื่อ โดยจะไม่มีผลกระทบต่อคุณภาพการบริการหรือการรักษาพยาบาลที่ท่านพึงได้รับตามสิทธิ</div>`,
      actionBtnText: "ยินยอม",
      cancleBtnText: "ยกเลิก"
    }
    this.consentModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  }

  openConfirmToEmailModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConfirm";
    dialogConfig.data = {
      name: "confirmEmail",
      title: 'ลงทะเบียนสำเร็จ',
      description: "กรุณายืนยันบัญชีตามอีเมลที่ลงทะเบียนไว้",
      cancleBtnText: "ตกลง",
    }
    this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
  }

  passwordTypeToggle() {
    this.passwordType = !this.passwordType;
  }

  confirmPasswordTypeToggle() {
    this.confirmPasswordType = !this.confirmPasswordType;
  }

}
